/**
 * Nhóm nhận thông báo "trận PK bắt đầu" — trùng PK_NOTIFY_GROUPS của server
 * (src/pk-start-notify) và cách chia người dùng của Chính sách nhắn tin:
 * Admin/MOD → Quản lý; Agency; Creator; người có phòng ban → Nhân sự; còn lại
 * → Người dùng.
 */
export type PkNotifyGroup = 'MANAGEMENT' | 'STAFF' | 'CREATOR' | 'AGENCY' | 'PUBLIC';

export const PK_NOTIFY_GROUP_OPTIONS: { value: PkNotifyGroup; label: string }[] = [
  { value: 'MANAGEMENT', label: 'Quản lý & quản trị (MOD, ADMIN)' },
  { value: 'STAFF', label: 'Nhân sự công ty (có phòng ban)' },
  { value: 'CREATOR', label: 'Creator' },
  { value: 'AGENCY', label: 'Đối tác (Agency)' },
  { value: 'PUBLIC', label: 'Người dùng (fan) — dễ làm phiền' },
];

/** Mặc định: mọi người trong công ty, không gồm Người dùng (fan). */
export const PK_NOTIFY_DEFAULT_GROUPS: PkNotifyGroup[] = [
  'MANAGEMENT',
  'STAFF',
  'CREATOR',
  'AGENCY',
];

/** "Việt Nam" / "Viet Nam" / "Vietnam" / "VN" → true (bỏ dấu, khoảng trắng). */
export const isVietnam = (country?: string | null) => {
  const key = (country ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');
  return key === 'vietnam' || key === 'vn';
};

/** 2 cờ Việt Nam → Nội địa; Việt Nam + nước khác → Quốc tế (giống app). */
export const isInternationalPk = (country1?: string | null, country2?: string | null) => {
  const a = (country1 ?? '').trim();
  const b = (country2 ?? '').trim();
  if (!a || !b) return false;
  if (isVietnam(a) && isVietnam(b)) return false;
  return a.toLowerCase() !== b.toLowerCase();
};
